import es from './es'
import en from './en'

const translations = { es, en }

export const getTranslation = (language, path) => {
	const keys = path.split('.')
	let result = translations[language]
	for (const key of keys) {
		if (result === undefined) return path
		result = result[key]
	}
	return result !== undefined ? result : path
}

export const t = (language, path, params = {}) => {
	let text = getTranslation(language, path)
	if (typeof text === 'string') {
		Object.entries(params).forEach(([key, value]) => {
			text = text.replace(new RegExp(`\\{${key}\\}`, 'g'), value)
		})
	}
	return text
}

export default translations
